export default __webpack_public_path__ + "static/0081-b2dde50a67ed8dbc885890cca21350ec.png";